module.exports = __webpack_public_path__ + "img/2.59907945.png";